import OSS from 'ali-oss'
import { DateFormat2 } from '../date/DateUtil'

export default class FileUpload {
  // TODO 完善文件上传，支持sts
  // 替换未sts,https://help.aliyun.com/zh/oss/developer-reference/installation?spm=5176.87240.400427.54.1fdd4614uR5ybh
  private ossClient = new OSS({
    region: 'oss-cn-beijing',
    bucket: 'cysccc',
    accessKeyId: 'LTAI5t79NYfbrKJJZDhcy6b5',
    accessKeySecret: 'bSKr2XmdzTqAynJn5fOHXfwXLIyzsA',
    secure: true,
    timeout: 3600000,
  })

  public percentage = 0
  // 分批大小（大于6Mb）
  public multSize = 1024 * 1024

  public async fileUpload(file: any): Promise<any> {
    const size = file.size
    let result = {}
    if (size > this.multSize) {
      console.log('分片上传')
      result = await this.multipartUpload(file)
    } else {
      console.log('简单上传')
      result = await this.simpleUpload(file)
    }
    // 获取文件宽高
    const r = await this.loadFileWH(file, result)
    return r
    // return result
  }

  // 获取文件的宽高
  private async loadFileWH(file: any, result: any) {
    return new Promise((resolve) => {
      const ft = file.type
      if (ft.indexOf('image') != -1) {
        // 图片
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function () {
          const img = new Image()
          img.src = reader.result as string
          img.onload = function () {
            result.width = img.width
            result.height = img.height
            resolve(result)
          }
        }
      } else if (ft.indexOf('video') != -1) {
        // 视频
        const videoEl = document.createElement('video')
        videoEl.src = URL.createObjectURL(file)
        videoEl.addEventListener('loadedmetadata', function () {
          result.width = videoEl.videoWidth
          result.height = videoEl.videoHeight
          resolve(result)
        })
      } else {
        result.width = 0
        result.height = 0
        resolve(result)
      }
    })
  }

  // 简单的文件上传
  private async simpleUpload(file: any) {

    // 随机生成文件名
    const fileName = this.createFileName(file.name)

    await this.ossClient.put(fileName, file)

    const baseUrl = 'https://cysccc.oss-cn-beijing.aliyuncs.com/'
    return { res: { status: 200 }, url: baseUrl + fileName }
    // return result
  }

  // 生成文件名
  private createFileName(fileName: string) {
    // 获取文件后缀
    const lastIndex = fileName.lastIndexOf('.')
    const suffix = fileName.substring(lastIndex)

    // 随机生成文件名
    const fn = 'file/' + DateFormat2(new Date()) + '/' + this.randomStr(10) + suffix
    return fn
  }
  private randomStr(len: number) {
    len = len || 8
    const chars = '12345678ABCDEFGHIJKLMOPKRSTUVWXYZ'
    const maxPos = chars.length
    let str = ''
    for (let i = 0; i < len; i++) {
      str += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return str
  }

  // 分片上传
  private async multipartUpload(file: any) {
    // 随机生成文件名
    const fileName = this.createFileName(file.name)

    const options = {
      // 获取分片上传进度、断点和返回值。
      progress: (p: number, cpt: any, res: any) => {
        this.percentage = Number((p * 100).toFixed(0))
        console.log('进度：'+this.percentage)
      },
      // 设置并发上传的分片数量。
      parallel: 4,
      // 设置分片大小。默认值为1 MB，最小值为100 KB。
      partSize: 1024 * 1024,
    }
    // this.ossClient.multipartUpload(fileName, file, options).then((result: any)=>{
    //   console.log(result)
    // })
    const result = await this.ossClient.multipartUpload(fileName, file, options)
    console.log('分片上传完成')
    console.log(result)
    const baseUrl = 'https://cysccc.oss-cn-beijing.aliyuncs.com/'
    return { res: { status: 200 }, url: baseUrl + fileName }
  }
}

// 导出
// const fileUpload = new FileUpload()
// export default fileUpload